export const apiConfig = {
  host: process.env.REACT_APP_API_URL,
  getFullURL: (path) => `${process.env.REACT_APP_API_URL}${path}`
};